import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();

  if (user === null) {
    // checking session
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center bg-white"
      >
        <div className="h-10 w-10 rounded-full border-4 border-slate-200 border-t-transparent animate-spin" />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  if (role && user.role !== role) {
    // Authenticated but wrong role
    return <Navigate to="/" replace />;
  }

  return children;
}
